(function ($, window, document) {
/**
 * Click handler for toggle buttons
 *
 * @param {object} ev - Event object
 */
function onToggleClick(ev) {
  ev.preventDefault();
}

/**
 * Enable My Insurance navigation behavior
 */
function enableMyInsuranceNavigation() {
  var $myInsuranceToggle = $('.js-dropdown-my-insurance-toggle'),
      $myInsuranceNavigation = $myInsuranceToggle.next('.dropdown-menu');

  $myInsuranceToggle.attr('data-toggle', 'dropdown');
  $myInsuranceToggle.bind('click', onToggleClick);

  $myInsuranceNavigation.removeClass('hidden');
}

/**
 * Disable My Insurance navigation behavior
 */
function disableMyInsuranceNavigation() {
  var $myInsuranceToggle = $('.js-dropdown-my-insurance-toggle'),
      $myInsuranceNavigation = $myInsuranceToggle.next('.dropdown-menu');

  $myInsuranceToggle.removeAttr('data-toggle');
  $myInsuranceToggle.unbind('click', onToggleClick);

  $myInsuranceNavigation.addClass('hidden');
}

/**
 * Set user login status
 *
 * @param {object} user - User object
 *                 user.logged - Authentication status
 *                 user.userName - User name
 */
function setUser(user) {
  //
  // Initialization
  // --------------
  function onDOMContentLoaded() {
    var $loginStatusText = $('.js-login-status-text'),
        titleLogin = $loginStatusText.data('title-login') || 'Kirjaudu sisään',
        titleLogout = $loginStatusText.data('title-logout') || 'Kirjaudu ulos',
        $body = $(document.body),
        isLogged = user.logged;

    if (isLogged) {
      $loginStatusText.text(titleLogout).parent().attr('href', '/kirjaudu-ulos/');
      $body.addClass('is-logged-in');
      enableMyInsuranceNavigation();
    } else {
      $loginStatusText.text(titleLogin);
      $body.removeClass('is-logged-in');
      disableMyInsuranceNavigation();
    }
  };
  if (document.readyState == 'loading') {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
  } else {
    onDOMContentLoaded();
  }
}

window.setUser = setUser;

})(jQuery, window, document);
